/* unplugin-vue-components disabled */import script from "./industryTree.vue?vue&type=script&setup=true&lang=js"
export * from "./industryTree.vue?vue&type=script&setup=true&lang=js"

import "./industryTree.vue?vue&type=style&index=0&id=c4485ace&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4485ace"]])

export default __exports__